var _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAchivPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 39,
    viewBox: "0 0 26 39",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.99683,
    y: 0.518921,
    width: 12.4733,
    height: 16.8118,
    rx: 6.23664,
    fill: "white",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.53914,
    y: 1.06124,
    width: 11.3887,
    height: 15.7272,
    rx: 5.69433,
    stroke: "white",
    strokeOpacity: 0.9,
    strokeWidth: 1.08463
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.489258 32.2444C0.489258 25.2059 6.19514 19.5 13.2337 19.5C20.2723 19.5 25.9781 25.2059 25.9781 32.2444V33.5601C25.9781 36.2779 23.7749 38.4811 21.0571 38.4811H5.41028C2.69247 38.4811 0.489258 36.2779 0.489258 33.5601V32.2444Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03157 32.2444C1.03157 25.5054 6.49465 20.0423 13.2337 20.0423C19.9728 20.0423 25.4358 25.5054 25.4358 32.2444V33.5601C25.4358 35.9784 23.4754 37.9388 21.0571 37.9388H5.41028C2.99199 37.9388 1.03157 35.9784 1.03157 33.5601V32.2444Z",
    stroke: "white",
    strokeOpacity: 0.9,
    strokeWidth: 1.08463
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchivPerson);
export default __webpack_public_path__ + "static/media/AchivPerson.0f90dcd989b3b2f88b448596efe996a4.svg";
export { ForwardRef as ReactComponent };